<template>
  <div class="colums small-11 medium-10 small-centered">
    <button
      class="primary button"
      :disabled="!$store.state.customCheckerboard.enableControls"
      @click="finish"
    >
      {{ translations.finishAlmostDoneCustomCheckerboard }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'finishAlmostDone',
  computed: {
    translations(){
      return this.$store.state.translations.data;
    }
  },
  methods: {
    finish() {
      if (this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.$checkerboardDataLayer.logAnalyticsEvent({
          eventLabel: this.$checkerboardDataLayer.labels.finish
        });
      } else {
        let eventAction = 'checkerboard';
        if (this.$store.getters['customCheckerboard/isSecondComponentFlow']) {
          eventAction += ' - second component';
        }
        dataLayer.push({
          'event': 'trackEvent',
          'eventCategory': 'customs',
          'eventAction': eventAction,
          'eventLabel': 'confirm design'
        });
      }

      this.$store.commit("customCheckerboard/SET_ENABLE_CONTROLS", false);
      this.$store.commit("customCheckerboard/NEXT_VIEW");
    }
  }
}
</script>
